import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Section from '../components/ui/Section';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import HeaderBanner from '../components/ui/HeaderBanner';
import { useLanguage } from '../i18n/LanguageContext';

// Immagini temporanee per le città (da sostituire con quelle reali)
const cities = {
  tuscany: [
    { name: 'Certaldo', image: 'https://images.unsplash.com/photo-1529260830199-42c24126f198?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'certaldo' },
    { name: 'Viareggio', image: 'https://images.unsplash.com/photo-1568822617270-2c1579f8dfe2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'viareggio' },
    { name: 'Firenze', image: 'https://images.unsplash.com/photo-1534445867742-43195f401b6c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'firenze' },
    { name: 'Garfagnana', image: 'https://images.unsplash.com/photo-1541369634898-9043732f4329?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'garfagnana' },
    { name: 'Siena', image: 'https://images.unsplash.com/photo-1537799943037-f5da89a65689?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'siena' },
    { name: 'Pisa', image: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'pisa' },
    { name: 'Lucca', image: 'https://images.unsplash.com/photo-1534321238895-da3ab632df3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'lucca' },
    { name: 'Forte dei Marmi', image: 'https://images.unsplash.com/photo-1596394723269-b2cbca4e6e33?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'forte-dei-marmi' },
    { name: 'Livorno', image: 'https://images.unsplash.com/photo-1612690761620-2411306e4e0d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'livorno' },
    { name: 'Abetone', image: 'https://images.unsplash.com/photo-1613672210253-25f1271f71b3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Toscana', slug: 'abetone' },
  ],
  liguria: [
    { name: 'Chiavari', image: 'https://images.unsplash.com/photo-1593690204710-f0a7da58be94?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Liguria', slug: 'chiavari' },
    { name: 'Manarola', image: 'https://images.unsplash.com/photo-1578146165547-9789cc765df5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Liguria', slug: 'manarola' },
    { name: 'Genova', image: 'https://images.unsplash.com/photo-1537221244690-375f4b32dea3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Liguria', slug: 'genova' },
    { name: 'Rapallo', image: 'https://images.unsplash.com/photo-1591806636957-11b805b8cb72?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Liguria', slug: 'rapallo' },
    { name: 'Sanremo', image: 'https://images.unsplash.com/photo-1584433305355-9cb71bba16f0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Liguria', slug: 'sanremo' },
    { name: 'La Spezia', image: 'https://images.unsplash.com/photo-1597131628347-c264cf3d4b8c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Liguria', slug: 'la-spezia' },
    { name: 'Monterosso', image: 'https://images.unsplash.com/photo-1539187577537-e54cf54ae3fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80', region: 'Liguria', slug: 'monterosso' },
  ]
};

const SearchContainer = styled(motion.div)`
  max-width: 600px;
  margin: 0 auto 4rem auto;
  position: relative;
  z-index: 2;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 1.2rem 1.8rem;
  border: 1px solid var(--border-color);
  background-color: rgba(18, 18, 18, 0.8);
  color: var(--text-primary);
  font-size: 1.1rem;
  border-radius: 8px;
  backdrop-filter: blur(5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: var(--accent-primary);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }
  
  &::placeholder {
    color: var(--text-secondary);
    opacity: 0.7;
  }
`;

const SearchIcon = styled.span`
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
  font-size: 1.2rem;
`;

const RegionContainer = styled(motion.div)`
  margin-bottom: 5rem;
`;

const RegionHeader = styled.div`
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

const RegionTitle = styled.h2`
  position: relative;
  display: inline-block;
  font-size: 2.5rem;
  letter-spacing: 1px;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 0;
    width: 80px;
    height: 2px;
    background: linear-gradient(90deg, var(--accent-primary), transparent);
  }
`;

const RegionCount = styled.span`
  font-size: 1rem;
  color: var(--text-secondary);
  background-color: rgba(255, 255, 255, 0.05);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-left: 1rem;
`;

const CityGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 2.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const CardWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  }
`;

const CardAction = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
  padding: 0 1.5rem 1.5rem;
  background-color: var(--bg-secondary);
`;

const CustomButton = styled(Button)`
  border-radius: 30px;
  padding: 0.7rem 1.8rem;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
    border: none;
  }
`;

const NoResultsMessage = styled(motion.div)`
  text-align: center;
  padding: 3rem;
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  margin-bottom: 2rem;
  
  h3 {
    margin-bottom: 1rem;
    color: var(--accent-primary);
  }
  
  p {
    color: var(--text-secondary);
  }
`;

// Definisco un'interfaccia per ogni città
interface City {
  name: string;
  image: string;
  slug: string;
}

const Attractions: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const { t, language } = useLanguage();
  
  const filteredCities = {
    tuscany: cities.tuscany.filter(city => 
      city.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (language === 'it' ? 'Toscana' : 'Tuscany').toLowerCase().includes(searchTerm.toLowerCase())
    ),
    liguria: cities.liguria.filter(city => 
      city.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      'Liguria'.toLowerCase().includes(searchTerm.toLowerCase())
    )
  };
  
  const hasResults = filteredCities.tuscany.length > 0 || filteredCities.liguria.length > 0;
  
  return (
    <>
      <HeaderBanner />
    
      <Section 
        title={t('attractions.title')}
        padding="5rem 0 2rem 0"
        centered={true}
        backgroundImage="https://images.unsplash.com/photo-1537799943037-f5da89a65689?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
        blurredBackground={true}
      >
        <SearchContainer
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <SearchInput 
            type="text"
            placeholder={t('attractions.search')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <SearchIcon>🔍</SearchIcon>
        </SearchContainer>
        
        {!hasResults && (
          <NoResultsMessage
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <h3>{t('attractions.no_results_title')}</h3>
            <p>{t('attractions.no_results_text')}</p>
          </NoResultsMessage>
        )}
        
        {filteredCities.tuscany.length > 0 && (
          <RegionContainer
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
          >
            <RegionHeader>
              <RegionTitle>{language === 'it' ? 'Toscana' : 'Tuscany'}</RegionTitle>
              <RegionCount>{filteredCities.tuscany.length} {filteredCities.tuscany.length === 1 ? t('attractions.destination') : t('attractions.destinations')}</RegionCount>
            </RegionHeader>
            <CityGrid>
              {filteredCities.tuscany.map((city, index) => (
                <CardWrapper 
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ 
                    duration: 0.5, 
                    ease: "easeOut",
                    delay: index * 0.1 
                  }}
                >
                  <Card
                    image={city.image}
                    title={city.name}
                    subtitle={language === 'it' ? 'Toscana' : 'Tuscany'}
                    hoverEffect={true}
                    link={`/citta/${city.slug}`}
                    animate={false}
                  />
                  <CardAction>
                    <Link to={`/citta/${city.slug}`}>
                      <CustomButton variant="outline-white">{t('common.discover')}</CustomButton>
                    </Link>
                  </CardAction>
                </CardWrapper>
              ))}
            </CityGrid>
          </RegionContainer>
        )}
        
        {filteredCities.liguria.length > 0 && (
          <RegionContainer
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeInOut" }}
          >
            <RegionHeader>
              <RegionTitle>Liguria</RegionTitle>
              <RegionCount>{filteredCities.liguria.length} {filteredCities.liguria.length === 1 ? t('attractions.destination') : t('attractions.destinations')}</RegionCount>
            </RegionHeader>
            <CityGrid>
              {filteredCities.liguria.map((city, index) => (
                <CardWrapper 
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ 
                    duration: 0.5, 
                    ease: "easeOut",
                    delay: index * 0.1 
                  }}
                >
                  <Card
                    image={city.image}
                    title={city.name}
                    subtitle="Liguria"
                    hoverEffect={true}
                    link={`/citta/${city.slug}`}
                    animate={false}
                  />
                  <CardAction>
                    <Link to={`/citta/${city.slug}`}>
                      <CustomButton variant="outline-white">{t('common.discover')}</CustomButton>
                    </Link>
                  </CardAction>
                </CardWrapper>
              ))}
            </CityGrid>
          </RegionContainer>
        )}
      </Section>
    </>
  );
};

export default Attractions; 